<template>
	<div style="width: 100%;height: 100%; font-family:'微软雅黑'">
		<div style="width: 100%;min-height: calc(100vh - 159px);background-color: #fff;overflow:hidden">
			<Header v-if="clearHead" />
			<router-view :key="datekey" />
		</div>
		<!-- <div class="foot">
			<div style="width:1200px; margin:0 auto">
				<span @click="goMore('/finance/project','创业项目')">创业项目</span> | <span @click="goMore('/finance/video','金融课堂')">金融课堂</span> | <span @click="goMore('/finance/investorCenter','金融顾问')">金融顾问</span> | <span @click="goMore('/finance/need','融资需求')">融资需求</span> | <span @click="goMore('/finance/activery','项目路演')">项目路演</span> | <span @click="goMore('/finance/law','法律法规')">法律法规</span>
			</div>
		</div> -->
		<LayoutFooter />
	</div>
</template>

<script>
import { platformName } from "@/config/platformConfig";
import Header from './components/head'
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2'
export default {
	name: "index",
	components: {
		Header,
		LayoutFooter,
	},
	data() {
		return {
			datekey:Date.now(),
			platformName,
			clearHead: true,
			current: ['首页'],
			clickMenuTitle: '',
			formState: {
				user: null,
			},
			formSearchBox: {
				city: null,
				company: null,
				project: null,
				demand: null
			},
		}
	},
	watch:{
		'$route.query.type'(){
			this.clearHeadFun()
		}
	},
	methods: {
		goMore(url,key) {
			this.$router.push({path: url, query: {type: key}})
		},
		onActiveryMore(url,name,type){
				
					this.$router.push({
						path:url,
						query:{type:name,activeKey:type}
				})
		},
		clearHeadFun(){
			this.clearHead = false;
			this.$nextTick(() => (
				this.clearHead = true
				))
		}
	}
}
</script>

<style scoped lang="less">
@import "./css/main.less";
:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after){
	border-bottom: 3px solid #1890ff
}
:deep(.ant-menu-item-selected){
	font-weight: 600;
}
:deep(.ant-btn){
	border-radius: 0;
}
.foot{
	background: #333333;
	color:#999999;
	padding-top: 20px;
	margin-bottom: -10px;
	span{
		cursor: pointer;
		padding:0 20px ;
		font-size: 16px;
		&:nth-child(1){
			padding-left:0
		}
	}
}

</style>